import React, { useCallback, useEffect, useState } from 'react';
import { instanceRef } from '../utils/axios';

const eliminarDuplicados = (list) =>
  list.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);

const cargarAseguradoraEmpresaProductos = async () => {
  try {
    const response = await instanceRef.instance.get('parametros/productos');
    return response.data.data;
  } catch (error) {
    // errorHandler(error, 'Error al obtener los datos');
  }
  return [];
};

const EmpresaContext = React.createContext({
  productos: undefined,
  aseguradoraEmpresaProductos: []
});
const { Provider, Consumer } = EmpresaContext;

const EmpresaProvider = ({ children }) => {
  const [
    aseguradoraEmpresaProductos,
    setAseguradoraEmpresaProductos
  ] = useState([]);
  const [productos, setProductos] = useState();
  const [productosTelefonicos, setProductosTelefonicos] = useState([]);
  const [productosPresenciales, setproductosPresenciales] = useState([]);
  const [aseguradoras, setAseguradoras] = useState([]);
  const [aseguradorasPorProducto, setAseguradorasPorProducto] = useState({});
  const [empresa, setEmpresa] = useState();
  const [producto, setProducto] = useState();
  const [empresaProducto, setEmpresaProducto] = useState(null);
  const [aseguradora, setAseguradora] = useState();

  const cargar = async (menu) => {
    if (!menu) {
      if (aseguradoraEmpresaProductos.length > 0) {
        return;
      }
      const result = await cargarAseguradoraEmpresaProductos();
      setAseguradoraEmpresaProductos(eliminarDuplicados(result));

      let empresaActual = {};
      if (result.length > 0) {
        empresaActual = result[0].aseguradoraEmpresa.empresa;
        setEmpresa(result[0].aseguradoraEmpresa.empresa);
      }

      const prods = eliminarDuplicados(result.map((item) => item.producto));
      const ordenados = prods.sort(function test(a, b) {
        const empresaProductoA =
          a.empresaProducto.find(
            ({ id_empresa }) => id_empresa === empresaActual.id
          ) || {};
        const empresaProductoB =
          b.empresaProducto.find(
            ({ id_empresa }) => id_empresa === empresaActual.id
          ) || {};
        if (empresaProductoA.orden < empresaProductoB.orden) {
          return -1;
        }
        if (empresaProductoA.orden > empresaProductoB.orden) {
          return 1;
        }
        return 0;
      });
      setProductos(ordenados);
      const aseguradorasPorProductoCargar = {};
      prods.forEach(({ id }) => {
        aseguradorasPorProductoCargar[id] = [];
      });
      result.forEach((element) => {
        aseguradorasPorProductoCargar[element.id_producto] = [
          ...aseguradorasPorProductoCargar[element.id_producto],
          element.aseguradoraEmpresa.aseguradora
        ];
      });
      setAseguradorasPorProducto(aseguradorasPorProductoCargar);

      const aseguradorasCargar = result.map(
        (item) => item.aseguradoraEmpresa.aseguradora
      );

      setAseguradoras(await eliminarDuplicados(aseguradorasCargar));
    } else {
      const result = await cargarAseguradoraEmpresaProductos();
      setAseguradoraEmpresaProductos(eliminarDuplicados(result));
      let empresaActual = {};
      if (result.length > 0) {
        empresaActual = result[0].aseguradoraEmpresa.empresa;
        setEmpresa(result[0].aseguradoraEmpresa.empresa);
      }
      const prods = eliminarDuplicados(result.map((item) => item.producto));
      // const idaseguradora = ordenados.aseguradoraProducto.id_aseguradora;
      let PlanesAsignados;
      try {
        const responseList = await instanceRef.instance.get(
          `/plan/asignados/empresa`,
          {
            params: { empresaId: result[0].aseguradoraEmpresa.empresa.id }
          }
        );
        if (responseList.data.data) {
          PlanesAsignados = responseList.data.data;
        }
      } catch (error) {
        // error
      }
      let productosconplan = [];
      if (PlanesAsignados) {
        prods.forEach((productolist) => {
          PlanesAsignados.forEach((plan) => {
            if (
              productolist.aseguradoraProducto[0].id_producto ===
              plan.aseguradoraProducto.id_producto
            ) {
              productosconplan.push(productolist);
            }
          });
        });
      }
      productosconplan = eliminarDuplicados(productosconplan);
      const ordenados = productosconplan.sort(function test(a, b) {
        const empresaProductoA =
          a.empresaProducto.find(
            ({ id_empresa }) => id_empresa === empresaActual.id
          ) || {};
        const empresaProductoB =
          b.empresaProducto.find(
            ({ id_empresa }) => id_empresa === empresaActual.id
          ) || {};
        if (empresaProductoA.orden < empresaProductoB.orden) {
          return -1;
        }
        if (empresaProductoA.orden > empresaProductoB.orden) {
          return 1;
        }
        return 0;
      });

      /* El producto de la Aseguradora debe contar con al menos una Vigencia Habilitada */
      let productosConVigencia = [];
      for (let z = 0; z < ordenados.length; z += 1) {
        const productoOrdenado = ordenados[z];
        for (
          let j = 0;
          j < productoOrdenado.aseguradoraProducto.length;
          j += 1
        ) {
          try {
            // eslint-disable-next-line no-await-in-loop
            const aseguradoraProductoVigenciasResponse = await instanceRef.instance.get(
              `aseguradoraproducto/vigencia/${productoOrdenado.aseguradoraProducto[j].id_aseguradora}/${productoOrdenado.aseguradoraProducto[j].id_producto}`
            );
            if (aseguradoraProductoVigenciasResponse.data?.data) {
              const vigenciaHabilitado = aseguradoraProductoVigenciasResponse.data?.data.find(
                (element) => element.habilitado === true
              );
              if (vigenciaHabilitado) {
                productosConVigencia = [
                  ...productosConVigencia,
                  productoOrdenado
                ];
              }
            }
          } catch (error) {
            // errorHandler(error, 'Error al obtener los productos');
          }
        }
      }
      setProductos(productosConVigencia);
      const aseguradorasPorProductoCargar = {};
      prods.forEach(({ id }) => {
        aseguradorasPorProductoCargar[id] = [];
      });
      result.forEach((element) => {
        aseguradorasPorProductoCargar[element.id_producto] = [
          ...aseguradorasPorProductoCargar[element.id_producto],
          element.aseguradoraEmpresa.aseguradora
        ];
      });
      if (result.length > 0) {
        const result2 = await instanceRef.instance.get(
          `aseguradoraempresaproducto/productos/telefonica/${result[0].aseguradoraEmpresa.empresa.id}`
        );
        const prodtelef = result2.data.data.rows.filter(
          (e) => e.venta_telefonica === true
        );
        const prodtelefconvig = [];
        prodtelef.forEach((element) => {
          productosConVigencia.forEach((element2) => {
            if (element.producto.id === element2.id) {
              prodtelefconvig.push(element.producto);
            }
          });
        });

        setProductosTelefonicos(await eliminarDuplicados(prodtelefconvig));

        // Seccion de productos venta Presencial
        // se filtran los productos que tienen venta presencial true en la tabla aseguradoraempresaproducto
        const prodPresencial = result2.data.data.rows.filter(
          (productoActual) => productoActual.venta_presencial === true
        );
        const prodEnPresencialConvig = [];

        prodPresencial.forEach((productoConPresencial) => {
          productosConVigencia.forEach((productoVigente) => {
            if (productoConPresencial.producto.id === productoVigente.id) {
              prodEnPresencialConvig.push(productoConPresencial.producto);
            }
          });
        });

        setproductosPresenciales(
          await eliminarDuplicados(prodEnPresencialConvig)
        );
      }

      // setAseguradorasPorProducto(aseguradorasPorProductoCargar);
      const filtroAseguradoraPorProductoCargar = {};
      Object.keys(aseguradorasPorProductoCargar).forEach((element) => {
        const auxAseguradoras = [];
        aseguradorasPorProductoCargar[element].forEach((element2) => {
          if (PlanesAsignados) {
            PlanesAsignados.forEach((element3) => {
              if (
                element2.id ===
                  element3.aseguradoraEmpresaProducto.aseguradoraEmpresa
                    .id_aseguradora &&
                Number(element) === element3.aseguradoraProducto.id_producto
              ) {
                auxAseguradoras.push(element2);
              }
            });
          }
        });
        filtroAseguradoraPorProductoCargar[element] =
          auxAseguradoras.length > 0
            ? eliminarDuplicados(auxAseguradoras)
            : null;
      });
      setAseguradorasPorProducto(filtroAseguradoraPorProductoCargar);

      const aseguradorasCargar = result.map(
        (item) => item.aseguradoraEmpresa.aseguradora
      );
      setAseguradoras(await eliminarDuplicados(aseguradorasCargar));
    }
  };

  const updateProducto = (productoParam) => {
    setProducto(productoParam);
    updateAseguradora(0);
  };

  const getProductoActual = useCallback(() => {
    if (!productos) {
      return {};
    }
    const actual = productos.find((item) => item.id === producto);
    return actual || {};
  }, [producto, productos]);

  const updateAseguradora = (aseguradoraParam) => {
    setAseguradora(aseguradoraParam);
  };

  // const getProductoByPath = (path) => {
  //   const codigoTipoProducto = TIPOS_PRODUCTOS.find(
  //     ({ link }) => link === path
  //   );
  //   return productos.find(({ codigo }) => codigo === codigoTipoProducto.codigo);
  // };

  // const getAseguradoraByPath = (path) => {
  //   return aseguradoras.find(
  //     ({ descripcion }) => descripcion.toLowerCase() === path
  //   );
  // };

  // const getAseguradoraEmpresaProductoByPath = (
  //   pathProducto,
  //   pathAseguradora
  // ) => {
  //   const productoByPath = getProductoByPath(pathProducto);
  //   const aseguradoraByPath = getAseguradoraByPath(pathAseguradora);

  //   if (!productoByPath || !aseguradoraByPath) {
  //     return;
  //   }

  //   const encontrado = aseguradoraEmpresaProductos.find(
  //     (item) =>
  //       item.id_producto === productoByPath.id &&
  //       item.aseguradoraEmpresa.id_aseguradora === aseguradoraByPath.id
  //   );
  //   return encontrado;
  // };

  useEffect(() => {
    cargar(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Provider
      value={{
        aseguradoraEmpresaProductos,
        productos,
        productosTelefonicos,
        productosPresenciales,
        producto,
        getProductoActual,
        aseguradoras,
        aseguradora,
        empresa,
        aseguradorasPorProducto,
        empresaProducto,
        setEmpresaProducto,
        updateProducto,
        updateAseguradora,
        cargar
      }}
    >
      {children}
    </Provider>
  );
};

export default EmpresaContext;
export { Consumer as EmpresaConsumer, EmpresaProvider };
